import React, { Component, forwardRef } from "react";
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import InfoIcon from '@material-ui/icons/Info';
import MenuLeftNav from "./MenuLeftNav";
import { Field, FieldArray, reduxForm, getFormValues } from 'redux-form'
import asyncValidate from './asyncValidate';
import { connect } from "react-redux";
import { IconButton, Tooltip, CircularProgress } from '@material-ui/core';
import axios from "axios";
import SweetAlert from 'react-bootstrap-sweetalert';
import { Fab } from '@material-ui/core';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import './custom-style.css';
import Divider from '@material-ui/core/Divider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as auth from "../../store/ducks/auth.duck";
import { checkModulePermission } from "../../crud/auth.crud";

import MaterialTable, { MTableToolbar } from 'material-table';
import {
    Portlet,
    PortletBody,
    PortletHeader,
    // PortletHeaderToolbar
} from "../../partials/content/Portlet";
import clsx from "clsx";

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import Modal from './Modal';
import { Helmet } from 'react-helmet'
library.add(fas)

// Styles
const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} color="primary" ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} color="primary" ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};


class Roles extends Component {
    constructor(props) {
        super(props)
        this.state = {
            roleList: [],
            authToken: '',
            currentPage: 0,
            currentSortOrder: "DESC",
            sortBy: "id",
            rowsPerPage: 10,
            textToSearch: '',
            totalCount: 0,
            sweetOpenConfirm: false,
            recordToDelete: {},
            sweetOpenSuccess: false,
            sweetOpenError: false,
            totalRecords: 0,
            isPermitted: true,
            isDeletePermitted: true,
            isEditPermitted: true,
            isAddPermitted: true,
            isLoading: false,
            id: "",
            isDelete: true,
            showModal: false,
        }
    }
    async handleEdit(row) {
        this.props.history.push(`/role/edit/${row.id}`)
    }

    async handleDelete(row) {
        await this.setState({ sweetOpenConfirm: true, recordToDelete: row });
    }
    async deleteRecord() {
        this.props.deleteRoleDetailRequest({
            id: this.state.recordToDelete.id.toString(),
            moduleName: "Role",

        })
        this.setState({ sweetOpenConfirm: false });
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    changePage = async (event) => {
        // await this.setState({ currentPage: event, isLoading:true });
        await this.setState({
            currentPage: event + 1,
            rowsToSkip: parseInt(event) > 0 ? parseInt(event) * parseInt(this.state.rowsPerPage) : 0,
            isLoading: true,
        });
        this.props.fetchRoleListRequest({
            "ModuleName": "Roles",
            "LoggedInUserId": 1,
            "IsSuperAdmin": 1,
            "Search": "",
            "OrderByFieldParam": "display_name",
            "SortOrderParam": "",
            "PageSize": this.state.rowsPerPage,
            "PageNo": event,
        });
    }
    changeOrderBy = async (event) => {
        if (event === 0) {
            await this.setState({ sortBy: "field_name" });
        }
    }
    changeRowsPerPage = async (event) => {
        await this.setState({ rowsPerPage: event, isLoading:true  });
        // this.props.fetchRoleListRequest({
        //     "ModuleName": "Roles",
        //     "LoggedInUserId": 1,
        //     "IsSuperAdmin": 1,
        //     "Search": "",
        //     "OrderByFieldParam": "display_name",
        //     "SortOrderParam": "",
        //     "PageSize": event,
        //     "PageNo": this.state.currentPage,
        // });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.deleteRoleResponse) {
            if (nextProps.deleteRoleResponse && nextProps.deleteRoleResponse != this.props.deleteRoleResponse) {
                if (nextProps.deleteRoleResponse.success) {
                    this.setState({isLoading:true })
                    this.props.fetchRoleListRequest({
                        "ModuleName": "Roles",
                        "LoggedInUserId": 1,
                        "IsSuperAdmin": 1,
                        "Search": "",
                        "OrderByFieldParam": "display_name",
                        "SortOrderParam": "",
                        "PageSize": this.state.rowsPerPage,
                        "PageNo": this.state.currentPage
                    });
                    this.deleteRoleAlert(nextProps.deleteRoleResponse.message, 'success');
                }
                else {
                    this.deleteRoleAlert(nextProps.deleteRoleResponse.message, 'error');
                }
            }
        }
        this.setState({isLoading:nextProps.loading})
    }

    deleteRoleAlert(msg, type) {
        let getAlert = '';
        if (type == 'success') {
            getAlert = () => (
                <SweetAlert
                    success
                    title={msg}
                    onConfirm={() => this.hideAlert()}
                >
                </SweetAlert>
            );
        } else {
            getAlert = () => (
                <SweetAlert
                    error
                    title={msg}
                    onConfirm={() => this.hideAlert()}
                >
                </SweetAlert>
            );
        }
        this.setState({
            alert: getAlert(),
            showModal: ! this.state.showModal,
        });
    }
    hideAlert() {
        this.setState({
            alert: null,
            showModal: false,
        });
    }

    componentDidMount() {
        this.setState({
            isLoading:true
        })
        this.props.fetchRoleListRequest({
            "ModuleName": "Roles",
            "LoggedInUserId": 1,
            "IsSuperAdmin": 1,
            "Search": "",
            "OrderByFieldParam": "display_name",
            "SortOrderParam": "",
            "PageSize": this.state.rowsPerPage,
            "PageNo": this.state.currentPage
        });
    }

    render() {
        this.state.totalRecords = this.props.totalRecords;
        this.state.roleList = this.props.roleListResponse;
        const { showModal } = this.state;
        return (
                <>
                {
                showModal ? (
                    <Modal>
                        {this.state.alert}
                    </Modal>
                ) : null
                }
                <Helmet>
                    <title>Role List | Scorecard</title>
                </Helmet>
            <div className="main-content-body roles role-list">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3 left-side-bar">
                            <MenuLeftNav isExpand={{ expand: "role", active: "role" }}></MenuLeftNav>
                        </div>
                        {/* <div className="col-lg-3">
                        <MenuLeftNav isExpand={{ expand: "panel1", active: "roles" }}></MenuLeftNav>
                    </div> */}
                        <div className="col-lg-9 right-content-wrap mt-4  mb-5">
                            <div className="roles-wrap">
                                <div >
                                    <p className="main-heading">Manage Roles</p>
                                </div>
                            <div className="tbl-container">
                                <div className="form-inline" style={{ justifyContent: "space-between", padding: "0px 10px" }} >
                                    <p className="heading" >Role Listing</p>
                                    {checkModulePermission("add-role") === true &&
                                        <button style={{ width: 120, height: 40, padding: 10, borderRadius: 0 }}
                                            id="kt_login_signin_submit"
                                            type="submit"
                                            onClick={() => this.props.history.push(`role/add`)}
                                            className={`btn btn-primary btn-elevate kt-login__btn-primary button-big mr-2 ${clsx(
                                                {
                                                    "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": false
                                                }
                                            )}`}
                                        >
                                            <AddIcon />  Add Role
                                        </button>
                                        }
                                </div>
                                        <Divider />
                                <div style={{padding:15 ,paddingBottom: 45}}>
                                    <MaterialTable
                                        className="role-list"
                                        icons={tableIcons}
                                        isLoading={this.state.isLoading}
                                        onSearchChange={this.changeSearch}
                                        onChangePage={this.changePage}
                                        onOrderChange={this.changeOrderBy}
                                        onChangeRowsPerPage={this.changeRowsPerPage}
                                        columns={[
                                            {
                                                title: 'Name',
                                                field: 'name',
                                                sortable: true,
                                            }
                                        ]}
                                        data={this.state.roleList}
                                        page={this.state.currentPage}
                                        totalCount={this.state.totalRecords}
                                        actions={[
                                            {
                                                icon: 'edit',
                                                onClick: (event, rowData) => this.handleEdit(rowData)
                                            },
                                            {
                                                icon: 'delete',
                                                onClick: (event, rowData) => this.handleDelete(rowData),
                                            },

                                        ]}
                                        localization={{
                                            body: { emptyDataSourceMessage: this.state.isLoading ==true
                                                        ? "Loading..." : "No roles to display"
                                                    }
                                                }}
                                        components={{
                                            Action:
                                                props => {
                                                    if (this.state.isEditPermitted) {
                                                        if (props.action.icon === 'edit' && checkModulePermission("edit-role") == true) {
                                                            return (
                                                                <Tooltip title="Edit Role" style={{ marginLeft: "auto" }}>
                                                                    <IconButton aria-label="edit" onClick={(event) => props.action.onClick(event, props.data)} >
                                                                        <FontAwesomeIcon icon={["fa", "edit"]} style={{ width: 18 }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            )
                                                        }
                                                    } else { return null }
                                                    if (props.action.icon === 'delete' && props.data.isDelete && checkModulePermission("delete-role") == true) {
                                                        return (

                                                            <Tooltip title="Delete Role">
                                                                <IconButton aria-label="delete" onClick={(event) => props.action.onClick(event, props.data)}>
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        )
                                                    }
                                                    else { return null }
                                                }
                                        }}
                                        options={{
                                            toolbar: false,
                                            showTitle: false,
                                            search: false,
                                            actionsColumnIndex: -1,
                                            draggable: false,
                                            pageSize: 10,
                                            pageSizeOptions: [5, 10, 20, 50, 100],
                                            cellStyle: {
                                                padding: "10px",
                                                color: '#575962',
                                                fontSize: "13px",

                                            },
                                            headerStyle: {
                                                backgroundColor: '#f4f3f8',
                                                color: '#575962',
                                                padding: "15px 10px",
                                                fontSize: "13px"
                                            },
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.state.sweetOpenConfirm && (
                        <SweetAlert
                            warning
                            showCancel
                            confirmBtnText="Yes, delete it!"
                            confirmBtnBsStyle="danger"
                            title="Are you sure you want to delete this Role?"
                            onConfirm={this.deleteRecord.bind(this)}
                            onCancel={() => this.setState({ sweetOpenConfirm: false })}
                            cancelBtnBsStyle="default"
                            focusCancelBtn
                        >
                            You want to delete this Role!
                        </SweetAlert>
                    )
                }
            </div>
            </div>
            </>
        )
    }
}




function mapStateToProps(state) {
    return {
        roleListResponse: state.auth.roleListResponse !== undefined ? state.auth.roleListResponse.liRoleResponse : [],
        totalRecords: state.auth.roleListResponse !== undefined ? state.auth.roleListResponse.listCount : 0,
        loading: state.auth.loading,
        deleteRoleResponse: state.auth.deleteRoleResponse,
    }
}

Roles = reduxForm({
    form: 'Roles',
    asyncValidate,
    enableReinitialize: true,
    destroyOnUnmount: false
})(Roles);

const mapDispatchToProps = (dispatch) => {
    return {

        fetchRoleListRequest: ({
            ModuleName,
            LoggedInUserId,
            IsSuperAdmin,
            Search,
            OrderByFieldParam,
            SortOrderParam,
            PageSize,
            PageNo,
        }) => dispatch(auth.actions.fetchRoleListRequest({
            ModuleName,
            LoggedInUserId,
            IsSuperAdmin,
            Search,
            OrderByFieldParam,
            SortOrderParam,
            PageSize,
            PageNo,
        })),
        deleteRoleDetailRequest: ({
            id,
            moduleName,
        }) => dispatch(auth.actions.deleteRoleDetailRequest({
            id,
            moduleName,
        }))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Roles);
